import { Outlet } from 'react-router-dom';

export default function PublicOutlet() {
    return <Outlet />;
}